// 261023 E3-P3h4c (FE) — thân «hộp hậu quả» (mockup `cons`): lead → «Sẽ thành Cũ / cần làm lại» → «Có thể cần xem lại» (khi BE có) → «Không đổi».
// Không import antd (test được). Vỏ Modal + nút ở `ConsequenceModal.tsx`. Chữ từng dòng là của BE (đã qua redactMoney ở `consequenceView.ts`).
import React from 'react';
import type { ConsequenceView } from './consequenceView';
import type { ConsequenceStatus } from './useConsequencePreview';

interface Props {
  lead: string;
  status: ConsequenceStatus;
  view: ConsequenceView | null;
  /** Câu báo sau 409 (dữ liệu vừa đổi) — đã tải lại hệ quả. */
  notice: string | null;
  /** HỘP CŨ: vẽ khi preview không dùng được (lỗi / BE cũ / hình lạ / treo) — người dùng vẫn xác nhận được. */
  fallback: React.ReactNode;
}

const ConsequenceBody: React.FC<Props> = ({ lead, status, view, notice, fallback }) => (
  <div className="wb-cons">
    <p className="wb-cons-lead">{lead}</p>
    {notice && <div className="wb-cons-notice" role="status">{notice}</div>}
    {status === 'loading' && <div className="wb-cons-wait" role="status">Đang kiểm tra hệ quả…</div>}
    {status === 'fallback' && fallback}
    {status === 'ready' && view && (
      <div aria-label="Hệ quả của thao tác">
        {!view.canCommit && (
          <div className="wb-cons-box wb-cons-block" role="alert">
            <ul>{view.blockers.map((b, i) => <li key={i}>{b}</li>)}</ul>
          </div>
        )}
        {view.groups.map((g) => (
          <div className={`wb-cons-box wb-cons-${g.tone}`} key={g.key}>
            <b>{g.title}</b>
            <ul>{g.items.map((t, i) => <li key={i}>{t}</li>)}</ul>
          </div>
        ))}
        {view.aiLine && <div className="wb-cons-ai">{view.aiLine}</div>}
      </div>
    )}
  </div>
);

export default ConsequenceBody;
